import ConsultarEventos from "@/views/eventos/eventos/ConsultarEventos.vue";
import EditarEvento from "@/views/eventos/eventos/EditarEvento.vue";
import DetalhesEvento from "@/views/eventos/eventos/DetalhesEvento.vue";

import ConsultarProgramacoes from "@/views/eventos/programacao-evento/ConsultarProgramacoes.vue";
import EditarProgramacao from "@/views/eventos/programacao-evento/EditarProgramacao.vue";
import DetalhesProgramacao from "@/views/eventos/programacao-evento/DetalhesProgramacao.vue";



const eventosRotas = [
  {
    path: "/modulo-eventos/eventos",
    name: "eventos--eventos",
    component: ConsultarEventos,
  },
  {
    path: "/modulo-eventos/eventos/novo",
    name: "eventos--eventos--novo",
    component: EditarEvento,
  },
  {
    path: "/modulo-eventos/eventos/editar/:idEvento?",
    name: "eventos--eventos--editar",
    component: EditarEvento,
    props: true,
  },
  {
    path: "/modulo-eventos/eventos/:idEvento",
    name: "eventos--eventos--detalhes",
    component: DetalhesEvento,
    props: true,
  },

  {
    path: "/modulo-eventos/programacoes",
    name: "eventos--programacoes",
    component: ConsultarProgramacoes,
  },
  {
    path: "/modulo-eventos/programacoes/editar/:idProgramacao?",
    name: "eventos--programacoes--editar",
    component: EditarProgramacao,
    props: true,
  },
  {
    path: "/modulo-eventos/programacoes/detalhes/:idProgramacao?",
    name: "eventos--programacoes--detalhes",
    component: DetalhesProgramacao,
    props: true,
  },
];

export { eventosRotas };
